import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import { RequestResult } from '@api/responseModels/requestResult';
import { ScheduleTemplateResp } from '@api/responseModels/worker/schedule/scheduleTemplateResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TSchedule } from '../common/types';
import { TState } from '../schedule';

export function useUpdateSchedule({
    state,
    crmID,
    workerPositionID,
    wpMode,
    messageApi,
    validateSchedule,
}: {
    state: TState;
    crmID: number | string;
    workerPositionID: number | string;
    wpMode: boolean;
    messageApi: any;
    validateSchedule: () => boolean;
}) {
    const navigate = useNavigate();

    const updateSchedule = useCallback(async () => {
        if (!validateSchedule()) return;

        state.isLoading = true;
        try {
            const result: RequestResult<ScheduleTemplateResp> = await CRMAPIManager.request(
                async (api) => {
                    const ts = state.schedule as TSchedule;
                    const startAt = moment(ts.start_schedule_at, 'YYYY-MM-DD');

                    return await api.updateSchedule(+crmID, ts.id, {
                        title: ts.title,
                        start_time: ts.start_time,
                        end_time: ts.end_time,
                        breaks: ts.breaks,
                        day_offs: ts.day_offs,
                        schedule_days: ts.schedule_days,
                        schedule_type: ts.schedule_type,
                        exception_days: ts.exception_days,
                        start_schedule_at: startAt.isAfter(moment(), 'day')
                            ? ts.start_schedule_at
                            : moment().add(2, 'day').format('YYYY-MM-DD'),
                    });
                }
            );

            if (result.errorCode) throw result;

            messageApi.success('График обновлён');
            navigate(
                wpMode
                    ? `/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`
                    : `/lk/worker/crm/${crmID}/schedule`
            );
        } catch (err) {
            messageApi.error('Ошибка при обновлении графика');
            console.error(err);
        } finally {
            state.isLoading = false;
        }
    }, [state, crmID, workerPositionID, wpMode, messageApi, navigate, validateSchedule]);

    return { updateSchedule };
}
